export const RoleValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.RoleName.trim()) {
      errors.RoleName = 'Role Name is required';
    } 
  
    return errors;
  };
  
 